// Words and numbers for the segment pages (UI-4): how old a count is, how
// long a build has run, and a sampled contact's values as a person reads them.

import { minute } from "@/components/emc/format";
import { CONSENT_WORDS, centsToEuros, subjectInfo } from "@/pages/segments/model";

/** "most", "4 perce", "2 órája", or the moment itself past a day. */
export function ago(value: string | null | undefined, now: number = Date.now()): string {
  if (!value) return "—";
  const at = new Date(value).getTime();
  if (Number.isNaN(at)) return "—";
  const seconds = Math.max(0, Math.round((now - at) / 1000));
  if (seconds < 60) return "most";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} perce`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} órája`;
  return minute(value);
}

/** "0:42", "12:05" — how long something has been running. */
export function elapsed(since: string | null | undefined, now: number = Date.now()): string {
  if (!since) return "—";
  const start = new Date(since).getTime();
  if (Number.isNaN(start)) return "—";
  const seconds = Math.max(0, Math.round((now - start) / 1000));
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
}

/** A day, "2026. 09. 12." — the sample's timestamps are days to a marketer. */
function day(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("hu-HU", { year: "numeric", month: "2-digit", day: "2-digit" });
}

/** One sampled value of one field, in words. */
export function sampleValue(field: string, value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  if (field.endsWith("_at") && typeof value === "string") return day(value);
  if (field === "consent_status" && typeof value === "string") return CONSENT_WORDS[value] ?? value;
  if (typeof value === "number") {
    if (subjectInfo(field)?.money) return `${centsToEuros(value)} €`;
    return value.toLocaleString("hu-HU");
  }
  return String(value);
}
